import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Steps, message, Input, Spin,
} from 'antd';
import { updateBlemishReportRequest } from '../../../redux/actions/questions_actions/update_blemish_report.actions';
import { getLeadProfileRequest } from '../../../redux/actions/get_lead_profile.actions';
import { setLeadValuationRequest } from '../../../redux/actions/set_lead_valuation.actions';
import { setLeadsCustomerValuationRequest } from '../../../redux/actions/set_customer_valuation.actions';
import { SFButton } from '../../../../../../components/SF-UI';
import { get, getVal, isNumber } from '../../../../../../shared/helpers';
import BlemishQuestion from './BlemishQuestion';

const { Step } = Steps;

class BlemishReportVersion3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 0,
        };

        this.dividedQuestionsBySteps = [
            [1],
            [2, 9],
            [10, 11],
            [12, 13],
            [14],
            [15, 23],
            [24, 32],
            [33, 40],
            [41, 47],
            // skipping from 48 to 58 because this questions not for agent
            [57, 58],
            [59],
        ];
    }


    /**
     * Category 1 - Just confirm
     * Category 2 - Critical
     * Category 3 - just a text
     * Category 4 - price adjustment
     * Category 5 - photo required
     * Category 6 - buy anyway
     * Category 7 - buy anyway + text
     */

    /*
        * Category 1 - default behavior(We_wont_buy_false_anyway)
        * Category 2 - default behavior(Value_if_set_true_then_we_wont_buy_false),
        * if yes, we continue as normally, if no, blemish report status failed and we won't buy this bike.
        * Category 3 - default behaviour(We_wont_buy_false_anyway), leaving a text comment and we continue anyway
        * Category 4 - default behaviour(Value_if_set_true_then_price_adjustment_required),
        * but also can be specific questions with Value_if_set_false_then_price_adjustment_required
        * Category 5 - default behaviour(Value_if_set_true_then_additional_photos_required)
        * Category 6 - default behaviour(We_wont_buy_false_anyway)
        * Category 7 - default behaviour(We_wont_buy_false_anyway)
        * all questions, even critical, must have note
    */


    valueHandlersArray = [
        'Value_if_set_true_then_we_wont_buy_false',
        'Value_if_set_true_then_we_wont_buy_true',
        'We_wont_buy_false_anyway',
        'Value_if_set_true_then_price_adjustment_required',
        'Value_if_set_false_then_price_adjustment_required',
        'Value_if_set_true_then_additional_photos_required',
    ];


    buildQuestionsOnStep = () => {
        const from = this.dividedQuestionsBySteps[this.state.currentStep][0];
        const to = this.dividedQuestionsBySteps[this.state.currentStep][1];

        if (!isNumber(to) && !to) {
            if (isNumber(from)) {
                return <BlemishQuestion key={from} questionNumber={from} />;
            }
            return <div className="question_container"><span className="failed-message">Something went wrong with question, please contact Admin.</span></div>;
        } if (isNumber(from) && isNumber(to)) {
            const stepContent = [];

            for (let index = from; index <= to; index++) {
                stepContent.push(<BlemishQuestion key={index} questionNumber={index} />);
            }

            return stepContent;
        }
        return <div className="question_container"><span className="failed-message">Something went wrong with question, please contact Admin.</span></div>;
    };


    next = () => {
        if (this.state.currentStep !== this.dividedQuestionsBySteps.length - 1) {
            const currentStep = this.state.currentStep + 1;
            this.setState({ currentStep });
        } else {
            message.warn('This is a last step in blemish report');
        }
    };

    finishBlemishHandler = () => {
        this.props.getLeadProfileRequest(this.props.lead_id);
        this.props.closeModal();
    };


    previousStep = () => {
        const { currentStep } = this.state;

        this.setState({ currentStep: currentStep - 1 });
    };

    isAllStepQuestionsNotAnswered = (step) => {
        const from = this.dividedQuestionsBySteps[step || this.state.currentStep][0];
        const to = this.dividedQuestionsBySteps[step || this.state.currentStep][1];
        let checkResult = true;

        for (let i = from; i <= to; i++) {
            const currentQuestion = getVal(this.props.blemish_report, `questions.question_${i}`);
            if (currentQuestion && currentQuestion.value === null) {
                checkResult = false;
                break;
            }
        }

        return checkResult;
    };

    handleUpdateValuation = (value) => {
        if ((value || value === 0) && Number(value) >= 0) {
            this.props.setLeadValuationRequest(this.props.lead_id, Number(value));
        } else {
            message.warn('Please enter numeric price');
        }
    };

    componentDidMount() {
        const blemish_questions = getVal(this.props.blemish_report, 'questions');

        if (blemish_questions) {
            for (let stepIndex = 0; stepIndex < this.dividedQuestionsBySteps.length; stepIndex++) {
                const fromQuestion = this.dividedQuestionsBySteps[stepIndex][0];
                const toQuestion = this.dividedQuestionsBySteps[stepIndex][1];

                if (!toQuestion) {
                    if (getVal(blemish_questions, `question_${fromQuestion}`) && getVal(blemish_questions, `question_${fromQuestion}`).value === null) {
                        this.setState({ currentStep: stepIndex });
                        break;
                    }
                } else if (this.isAllStepQuestionsNotAnswered(stepIndex) === false) {
                    this.setState({ currentStep: stepIndex });
                    break;
                }
            }
        }
    }

    render() {
        // ID of failed status in blemish report
        this.blemish_report_failed_status_id = '5c6bb394b8292a22d8128dff';
        // check for failed status, if failed === true, then we wont buy this bike, and blemish report is finished
        this.is_blemish_report_failed = this.props.blemish_report_status_id === this.blemish_report_failed_status_id;

        return (
            <div className="blemish-report">
                <Steps current={this.state.currentStep} size="small">
                    {this.dividedQuestionsBySteps.map(step => <Step key={Math.random()} />)}
                    {/* {this.stepsFromBlemishReport.map(item => <Step key={Math.random()} title={item.title}/>)} */}
                </Steps>
                <Spin tip="Saving question answer..." spinning={this.props.blemish_report_loading}>
                    <div className="step-content">
                        {
                            (this.state.currentStep === this.dividedQuestionsBySteps.length - 1)
                            && (getVal(this.props, 'Lead_valuations.valuations') && getVal(this.props, 'Lead_valuations.valuations').length !== 0)
                            && (
                                <Fragment>
                                    {
                                        getVal(this.props, 'Lead_valuations.customer_valuation')
                                    && (getVal(this.props, 'Lead_valuations.customer_valuation') !== 0)
                                    && (
                                        <p>
                                            Customer Looking For:&nbsp;
                                            <span style={{ fontStyle: 'italic' }}>
                                                &pound;
                                                {getVal(this.props, 'Lead_valuations.customer_valuation')}
                                            </span>
                                        </p>
                                    )
                                    }
                                    <div style={{ display: 'flex', margin: '5px 0 15px' }}>
                                        <span style={{ flexBasis: 170 }}>Update Valuation:</span>
                                        <Input.Search
                                            disabled={this.is_blemish_report_failed}
                                            type="number"
                                            style={{ marginBottom: 5 }}
                                            defaultValue={getVal(this.props.Lead_valuations, 'valuations.0.valuation')}
                                            placeholder="Use enter on the keyboard or click the send button to update the valuation"
                                            enterButton="Update"
                                            size="small"
                                            onSearch={this.handleUpdateValuation}
                                        />
                                    </div>
                                </Fragment>
                            )
                        }
                        {this.buildQuestionsOnStep()}
                    </div>
                </Spin>
                <div className="steps-action">
                    <div className="btn-toolbar">
                        {
                            this.state.currentStep > 0
                            && (
                                <SFButton onClick={this.previousStep}>
                                    Previous
                                </SFButton>
                            )
                        }
                        {
                            this.state.currentStep < this.dividedQuestionsBySteps.length - 1
                            && <SFButton disabled={!this.isAllStepQuestionsNotAnswered()} onClick={this.next} type="primary">Next</SFButton>
                        }
                        {
                            (this.is_blemish_report_failed || this.state.currentStep === this.dividedQuestionsBySteps.length - 1)
                            && (
                                <SFButton
                                    disabled={getVal(this.props.blemish_report, 'questions.question_59.value') === null}
                                    type="primary"
                                    onClick={this.finishBlemishHandler}
                                >
                                    Finish Blemish Report
                                </SFButton>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentUserId: get(state.App, 'App_content.user._id'),
    blemish_report_status_id: getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report.ref_lead_blemish_report_status'),
    lead_id: getVal(state, 'Leads.Lead_profile.Lead_general.root_id'),
    Lead_valuations: getVal(state, 'Leads.Lead_profile.Lead_valuations'),
    Lead_approval: getVal(state, 'Leads.Lead_profile.Lead_general.approval'),
    blemish_report: getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report'),
    blemish_report_loading: getVal(state, 'Leads.Lead_profile.Lead_blemish_report.blemish_report_loading'),
});

export default connect(mapStateToProps, {
    updateBlemishReportRequest,
    getLeadProfileRequest,
    setLeadValuationRequest,
})(BlemishReportVersion3);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BlemishReportVersion3.js